import { render, staticRenderFns } from "./CustomerSelectorTable.vue?vue&type=template&id=ba66f8ec&scoped=true&"
import script from "./CustomerSelectorTable.vue?vue&type=script&lang=js&"
export * from "./CustomerSelectorTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSelectorTable.vue?vue&type=style&index=0&id=ba66f8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba66f8ec",
  null
  
)

export default component.exports